// extracted by mini-css-extract-plugin
module.exports = {"AboutNumbersBlock__title":"AboutNumbersBlock_AboutNumbersBlock__title__9kFjq","AboutNumbersBlock__blocks":"AboutNumbersBlock_AboutNumbersBlock__blocks__aN_fp"};